import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  CalendarIcon,
  UserGroupIcon,
  Bars3Icon
} from '@heroicons/react/24/outline'
import {
  HomeIcon as HomeIconSolid,
  CalendarIcon as CalendarIconSolid,
  UserGroupIcon as UserGroupIconSolid
} from '@heroicons/react/24/solid'
import { useThemeColors } from '../../hooks/useThemeColors'
import { triggerHaptic } from '../../hooks/useMobile'
import '../mobile/MobileBottomNav.css'

interface NavItem {
  path: string
  label: string
  icon: React.ElementType
  iconActive: React.ElementType
}

const navItems: NavItem[] = [
  {
    path: '/dashboard',
    label: 'Home',
    icon: HomeIcon,
    iconActive: HomeIconSolid
  },
  {
    path: '/schedule',
    label: 'Schedule',
    icon: CalendarIcon,
    iconActive: CalendarIconSolid
  },
  {
    path: '/clients',
    label: 'Clients',
    icon: UserGroupIcon,
    iconActive: UserGroupIconSolid
  },
]

interface AdminMobileBottomNavProps {
  onMenuOpen: () => void
}

export default function AdminMobileBottomNav({ onMenuOpen }: AdminMobileBottomNavProps) {
  const location = useLocation()
  const { colors } = useThemeColors()

  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === path
    }
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="mobile-bottom-nav" style={{ '--primary-color': colors.primary } as React.CSSProperties}>
      <div className="mobile-bottom-nav-inner">
        {navItems.map((item) => {
          const active = isActive(item.path)
          const Icon = active ? item.iconActive : item.icon

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`mobile-nav-item ${active ? 'active' : ''}`}
              onClick={() => triggerHaptic('light')}
            >
              <div className="mobile-nav-icon">
                <Icon />
              </div>
              <span className="mobile-nav-label">{item.label}</span>
              {active && <div className="mobile-nav-indicator" />}
            </NavLink>
          )
        })}

        {/* More menu button */}
        <button
          className="mobile-nav-item mobile-nav-more"
          onClick={() => {
            triggerHaptic('light')
            onMenuOpen()
          }}
          onTouchEnd={(e) => {
            e.preventDefault()
            triggerHaptic('light')
            onMenuOpen()
          }}
          type="button"
          aria-label="Open menu"
        >
          <div className="mobile-nav-icon">
            <Bars3Icon />
          </div>
          <span className="mobile-nav-label">More</span>
        </button>
      </div>
    </nav>
  )
}
